import React from 'react'
import { Typography } from '@material-ui/core'
const CustomTypography = ({
  color,
  variant,
  component,
  children,
  align,
  className,
  gutterBottom,
  style,
}) => (
  <Typography
    color={color}
    variant={variant}
    component={component}
    align={align}
    className={className}
    gutterBottom={gutterBottom}
    style={style}
  >
    {children}
  </Typography>
)

export default CustomTypography
